<template>
  <ItemSideNav />

  <div class="pb-md-5 mb-5">
    <div class="container">        
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb mb-3">
          <li class="breadcrumb-item text-dark opacity-5">
            <a href="home.html">昀揚科技</a>
          </li>
          <li class="breadcrumb-item text-dark opacity-5">
            <a href="product.html">產品介紹</a>
          </li>
          <li class="breadcrumb-item text-dark opacity-5">
            <a href="tronedu.html">TronEdu</a>
          </li>
          <li
            class="breadcrumb-item text-dark active"
            aria-current="page"
          >
            TronEdu 技術支援
          </li>
        </ol>
      </nav>   
    </div> 

    <section>
      <div class="container">
        <div class="nav-wrapper position-relative end-0 mb-3">
          <ul
            class="nav nav-pills nav-fill p-1"
            role="tablist"
          >
            <li
              class="nav-item  col-12 col-md-6"
              role="presentation"
            >
              <a
                class="nav-link mb-0 px-0 py-2 active"
                data-bs-toggle="tab"
                href="#curriculump"
                role="tab"
                aria-controls="profile"
                aria-selected="true"
              >
                <i class="fa-solid fa-book-open-cover me-2" />Curriculum Platform 課程平台
              </a>
            </li>
            <li
              class="nav-item col-12 col-md-6"
              role="presentation"
            >
              <a
                class="nav-link mb-0 px-0 py-2"
                data-bs-toggle="tab"
                href="#examp"
                role="tab"
                aria-controls="dashboard"
                aria-selected="false"
                tabindex="-1"
              >
                <i
                  class="fas fa-graduation-cap me-2"
                  aria-hidden="true"
                />Exam Platform 命題平台
              </a>
            </li>                
            <div
              class="moving-tab position-absolute nav-link"
              style="padding: 0px; transition: all 0.5s ease 0s; transform: translate3d(0px, 0px, 0px); width: 452px;"
            >
              <a
                class="nav-link mb-0 px-0 py-2 active"
                data-bs-toggle="tab"
                href="#curriculump"
                role="tab"
                aria-controls="profile"
                aria-selected="true"
              >-</a>
            </div>
          </ul>
        </div>
        <div class="card card-background mb-4">
          <div
            class="full-background"
            style="background-image: url('assets/img/child2.jpg')"
          />
          <span class="mask bg-black-d" />
          <div class="card-body pt-10 col-12">
            <h4 class="text-white font-weight-normal">
              <i class="fa-solid fa-book-open-cover me-2" />創益學課程平台系統
            </h4>
            <p>TronEdu Curriculum Platform</p>
          </div>
        </div>    
        <div class="card card-background mb-4">
          <div
            class="full-background"
            style="background-image: url('assets/img/user.jpg')"
          /> 
          <span class="mask bg-black-d" />
          <div class="card-body pt-10 col-12">
            <h4 class="text-white font-weight-normal">
              <i
                class="fas fa-graduation-cap me-2"
                aria-hidden="true"
              />創益學命題平台系統
            </h4>
            <p>TronEdu Exam Platform</p>
          </div>
        </div>  
        <div class="row">
          <div class="col-lg-3">  
            <div class="card max-height-vh-70 overflow-auto overflow-x-hidden mb-5 mb-lg-0 min-vh-35">
              <div class="card-body p-2">
                <a
                  href="javascript:;"
                  class="d-block p-2 border-radius-lg bg-gradient-primary"
                >
                  <div class="d-flex align-items-center p-2"> 
                    <i class="text-white material-icons text-lg me-2">download</i>
                    <h6 class="text-white mb-0">主程式下載</h6>
                  </div>
                </a>
                <a
                  href="javascript:;"
                  class="d-block p-2"
                >
                  <div class="d-flex align-items-center p-2">
                    <i class="material-icons text-lg me-2">handyman</i> 
                    <h6 class="mb-0">教學手冊</h6>
                  </div>
                </a>               
                <a
                  href="javascript:;"
                  class="d-block p-2"
                >
                  <div class="d-flex align-items-center p-2">
                    <i class="material-icons text-lg me-2">menu_book</i>
                    <h6 class="mb-0">產品型錄</h6>
                  </div>
                </a>
                <a
                  href="javascript:;"
                  class="d-block p-2"
                >
                  <div class="d-flex align-items-center p-2">
                    <i class="material-icons text-lg me-2">play_circle</i>
                    <h6 class="mb-0">介紹影片</h6>
                  </div>
                </a>               
                <a
                  href="javascript:;"
                  class="d-block p-2"
                >
                  <div class="d-flex align-items-center p-2">
                    <i class="material-icons text-lg me-2">terminal</i>
                    <h6 class="mb-0">SDK</h6>
                  </div>
                </a>                
                <a
                  href="javascript:;"
                  class="d-block p-2"
                >
                  <div class="d-flex align-items-center p-2">
                    <i class="material-icons text-lg me-2">live_help</i>
                    <h6 class="mb-0">常見問題</h6>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div class="col-lg-9">
            <div
              class="tab-content mb-3"
              id="v-pills-tabContent"
            >   
              <div class="card min-vh-35">
                <div
                  class="tab-pane"
                  id="du_download"
                  role="tabpanel"
                  aria-labelledby="edu_download"
                >
                  <div class="table-responsive">
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr>
                          <th class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7">
                            版本名稱
                          </th>
                          <th class="text-center text-uppercase text-secondary text-xs font-weight-bolder opacity-7">
                            更新日期
                          </th>
                          <th class="text-center text-uppercase text-secondary text-xs font-weight-bolder opacity-7">
                            下載
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="align-middle w-60 ps-4 py-3">
                            <span class="font-weight-bold text-dark line1">題目轉檔工具v.12345</span>
                          </td>                  
                          <td class="align-middle text-center w-20 py-3">
                            <span class="text-secondary ">2023/04/18</span>
                          </td>
                          <td class="align-middle  text-center w-20 py-3">
                            <button
                              class="btn btn-icon btn-primary mb-0"
                              type="button"
                            >
                              <i class="material-icons text-lg me-1">download</i>
                              <span>下載</span>
                            </button>
                          </td>
                        </tr>                
                        <tr>
                          <td class="align-middle w-60 ps-4">
                            <span class="font-weight-bold text-dark py-3 line1">題目轉檔工具v.12345</span>
                          </td>                  
                          <td class="align-middle text-center w-20 py-3">
                            <span class="text-secondary ">2023/04/18</span>
                          </td>
                          <td class="align-middle  text-center w-20 py-3">
                            <button
                              class="btn btn-icon btn-primary mb-0"
                              type="button"
                            >
                              <i class="material-icons text-lg me-1">download</i>
                              <span>下載</span>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>    
              </div>
            </div>
            <div
              class="tab-content mb-3"
              id="v-pills-tabContent"
            >   
              <div class="card min-vh-35">
                <div
                  class="tab-pane"
                  id="du_download"
                  role="tabpanel"
                  aria-labelledby="edu_download"
                >
                  <div class="table-responsive">
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr>
                          <th class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7">
                            手冊名稱
                          </th>
                          <th class="text-center text-uppercase text-secondary text-xs font-weight-bolder opacity-7">
                            更新日期
                          </th>
                          <th class="text-center text-uppercase text-secondary text-xs font-weight-bolder opacity-7">
                            開啟
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="align-middle w-60 ps-4 py-3">
                            <span class="font-weight-bold text-dark">TronEdu Curriculum教學手冊</span>
                          </td>                  
                          <td class="align-middle text-center w-20 py-3">
                            <span class="text-secondary ">2023/04/18</span>
                          </td>
                          <td class="align-middle  text-center w-20 py-3">
                            <button
                              class="btn btn-icon btn-primary mb-0"
                              type="button"
                            >
                              <i class="material-icons text-lg me-1">menu_book</i>
                              <span>開啟</span>
                            </button>
                          </td>
                        </tr>                
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>       
            <div
              class="tab-content mb-3"
              id="v-pills-tabContent"
            >   
              <div class="card min-vh-35">
                <div
                  class="tab-pane"
                  id="du_download"
                  role="tabpanel"
                  aria-labelledby="edu_download"
                >
                  <div class="table-responsive">
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr>
                          <th class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7">
                            DM名稱
                          </th>
                          <th class="text-center text-uppercase text-secondary text-xs font-weight-bolder opacity-7">
                            更新日期
                          </th>
                          <th class="text-center text-uppercase text-secondary text-xs font-weight-bolder opacity-7">
                            下載
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="align-middle w-60 ps-4 py-3">
                            <span class="font-weight-bold text-dark">TronEdu Curriculum DM</span>
                          </td>                  
                          <td class="align-middle text-center w-20 py-3">
                            <span class="text-secondary ">2023/04/18</span>
                          </td>
                          <td class="align-middle  text-center w-15 py-3">
                            <button
                              class="btn btn-icon btn-primary mb-0"
                              type="button"
                            >
                              <i class="material-icons text-lg me-1">menu_book</i>
                              <span>開啟</span>
                            </button>
                          </td>
                        </tr>                
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>        
            <div
              class="tab-content mb-3"
              id="v-pills-tabContent"
            >   
              <div class="card min-vh-35 text-center">
                <div
                  class="tab-pane"
                  id="du_download"
                  role="tabpanel"
                  aria-labelledby="edu_download"
                >
                  <img
                    src="assets/img/dg3.jpg"
                    class="img-fluid"
                  >
                </div>
                <p class="text-danger my-1">
                  播放器滿版示意
                </p>
              </div>
            </div>
            <div
              class="tab-content mb-3"
              id="v-pills-tabContent"
            >   
              <div class="card min-vh-35">
                <div
                  class="tab-pane"
                  id="du_download"
                  role="tabpanel"
                  aria-labelledby="edu_download"
                >
                  <div class="table-responsive">
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr>
                          <th class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7">
                            問題描述
                          </th>
                          <th class="text-center text-uppercase text-secondary text-xs font-weight-bolder opacity-7">
                            問題類型
                          </th>
                          <th class="text-center text-uppercase text-secondary text-xs font-weight-bolder opacity-7">
                            發佈時間
                          </th>
                          <th class="text-center text-uppercase text-secondary text-xs font-weight-bolder opacity-7">
                            完整內容
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="align-middle w-55 ps-4 py-3">
                            <span class="font-weight-bold text-dark line1">問題問題問題</span>
                          </td>                  
                          <td class="align-middle text-center w-15 py-3">
                            <span class="text-secondary ">系統問題</span>
                          </td>                
                          <td class="align-middle text-center w-15 py-3">
                            <span class="text-secondary ">2023/04/18</span>
                          </td>
                          <td class="align-middle  text-center w-15 py-3">
                            <button
                              class="btn btn-icon btn-primary mb-0"
                              type="button"
                            >
                              <i class="material-icons text-lg me-1">search</i>
                              <span>查看</span>
                            </button>
                          </td>
                        </tr>                
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>


  <footer class="footer py-3 py-md-5 bg-gradient-dark position-relative overflow-hidden">
    <img
      src="assets/img/shapes/waves-white.svg"
      alt="pattern-lines"
      class="position-absolute start-0 top-0 w-100 opacity-1"
      loading="lazy"
    >
    <div class="container position-relative">
      <div class="row">
        <div class="col-md-6 me-auto my-auto text-md-start text-center">
          <a href="www.cloudraise.com ">
            <img
              src="assets/img/logo-ct-dark.png"
              class="mb-3 footer-logo"
              alt="main_logo"
            >
          </a>
          <h6 class="text-white font-weight-bold text-uppercase mb-2">
            Cloud Raise Technology
          </h6>
          <p class="text-white mb-0">
            Copyright © 2023 by Cloud Raise Technology.
          </p>
        </div>
        <div class="col-md-6 ms-auto text-md-end text-white d-none d-md-block">
          <p class="mb-1">
            新北市三重區重新路五段609巷<br class="d-md-none">14號5樓之3
          </p>
          <p class="mb-1">
            service@cloudraise.com
          </p>
          <p class="">
            02-29992891
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
/* eslint-disable import/no-absolute-path */
// eslint-disable-next-line import/no-unresolved
import { config } from '@/include/config';
import {
  h,
  ref,
  toRefs,
  reactive,
  watch,
  inject,
  onMounted,
  onBeforeUpdate,
  onUpdated
} from 'vue';
import { oltConsole, oAA , oAuth, oApiError , oFrame } from '@/lib/oltModule/initOltVue3';
import { SideNav , ItemSideNav , Header , ProductHeader , Footer } from '@/components/Frame';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';

export default {
  name: 'App',
  components: {
    ItemSideNav,
    //Header,
    //ProductHeader,
    //NavBar,
    // Settings,
    //Footer,
  },
  setup() {

    /**
     *  swal start
     */
    const swal = inject('$swal');
    /**
     *  swal end
     */

    const router = useRouter();
    const route = useRoute();
    const store = useStore();

    const nid = ref();

    //console.log('router.currentRoute.value : ', router.currentRoute.value.query);
    /*
    if(router.currentRoute.value.query.nid == null || router.currentRoute.value.query.nid == '' ){
      swal.fire({
        icon:'error',
        html:'路徑錯誤！！',
        buttonsStyling: true,
        confirmButtonClass: 'md-button md-success',
        //confirmButtonText:t('messages.confirm_button'),
      }).then( result => {
        if (result.value) {
          //console.log('result : ' , result);
          //emit('addCallBack');
          //router.go(-1);
          goToPage('/');
        }
      });
    }
	*/
    nid.value= router.currentRoute.value.query.nid ; 

    //console.log('nid' , nid.value);

    onMounted(async () => {
      chkLogin();
    });
    // Reload MDInput End

    onUpdated(async () => {
      // 修改 VUE 時 必需全部強制關閉 Modals 
      // eslint-disable-next-line no-undef
      //await oAdminFrame.closeAllModals() ;
    }) ;
    function goToPage(page){
      router.push( { path: page } );
    }


    function chkLogin(){
      let isLogin = oAuth.isLogin(store);

      if(!isLogin){
        //router.push({ path: '/AuthPage/SignIn' });
      }
    }

    return {
      hiddenHeader:false,
      // api setting
      setDebugMode: true,
      apiDebug: false,
      apiName: '',
      perPage: 3, //筆數
      pageMode: true,
      perPageOptions: [5, 10, 25, 50, 75, 100],
      // data
      userInfo:{coin:0 , point:0},
      token:null,
      nid,
      // function
      goToPage,
      chkLogin,
    };
  },
  created() {
  },
  mounted() {
    oFrame.initMD();
  },
  methods: {
  }
};
</script>
